import { useBottomSheet } from '@croquiscom-pvt/zds';

import { useCatalogProductIdParams, usePdpBaseInfo } from '@domains/pdp-common';

export const useProductMetadataService = () => {
  const { open: openPriceInfoBottomSheet } = useBottomSheet('custom');
  const params = useCatalogProductIdParams();
  const {
    product: {
      discount_info,
      product_price,
      product_price: { is_visible_discount_detail_button },
    },
  } = usePdpBaseInfo(params);

  return {
    discountInfo: discount_info,
    productPrice: product_price,
    isVisibleDiscountDetailButton: is_visible_discount_detail_button,
    priceInfo: {
      open: (children: React.ReactNode) =>
        openPriceInfoBottomSheet({
          children,
        }),
    },
  };
};
